/** 独立手机浏览器 /m；桌面 Layout 内嵌 /desktop-mobile */
export const MOBILE_STANDALONE_BASE = '/m'
export const MOBILE_DESKTOP_EMBED_BASE = '/desktop-mobile'

const BASES = [MOBILE_DESKTOP_EMBED_BASE, MOBILE_STANDALONE_BASE]

/**
 * 将 /m/... 或 /desktop-mobile/... 规范为后缀（如 /inventory/1）
 * @param {string} path
 */
export function mobilePathSuffix(path) {
  const p = String(path || '').split('?')[0]
  for (const base of BASES) {
    if (p === base) return '/'
    if (p.startsWith(`${base}/`)) return p.slice(base.length) || '/'
  }
  return p
}

/**
 * @param {import('vue-router').RouteLocationNormalizedLoaded | { path?: string }} route
 */
export function getMobileBaseFromRoute(route) {
  const p = route?.path || ''
  if (p === MOBILE_DESKTOP_EMBED_BASE || p.startsWith(`${MOBILE_DESKTOP_EMBED_BASE}/`)) {
    return MOBILE_DESKTOP_EMBED_BASE
  }
  return MOBILE_STANDALONE_BASE
}

export function isMobileWorkbenchPath(path) {
  const p = String(path || '').split('?')[0]
  return BASES.some((b) => p === b || p.startsWith(`${b}/`))
}

/**
 * @param {string} base
 * @param {string} suffix 如 inventory、dispatch/1
 */
export function joinMobilePath(base, suffix) {
  const b = String(base || MOBILE_STANDALONE_BASE).replace(/\/$/, '')
  const s = String(suffix || '').replace(/^\//, '')
  return s ? `${b}/${s}` : b
}
